<template>
    <c-sidebar-wrapper class="sidebar-wrapper">
        <slot></slot>
    </c-sidebar-wrapper>
</template>

<script>
import { CSidebarWrapper } from './Styles/Product/styled'

export default {
    name: 'SidebarWrapper',
    components: {
        'c-sidebar-wrapper': CSidebarWrapper
    }
}
</script>